// Add GST 

    jQuery(function() {
        $('.options-selection__input-select').on('change', function(){
            setTimeout(function(){
                if($('[name="id"]').val() != "{{ product.selected_or_first_available_variant.id }}"){
                    location.reload();
                }
            }, 1);
        });
    });



function addGST(price){
  console.log('### addGST ###', typeof(price), typeof(price) == 'string')
  if ( typeof(price) == 'string' ){
    if (price.includes('$') || price.includes(',')){
      price = price.replace('$', '')
      price = price.replace(',', '')
      price = price * 100
    }
  }
  let priceText;
  // [[tax-modified-2025]] TEMP

    let gst = (price * 3) / 23;
    priceText = ( (price - gst) * 0.01).toFixed(2);

  // Laybuy updates (PDP only)
  if ($('.laybuy-money[data-money-convertible]').length > 0){
    updateLaybuyPrice(`$${(priceText/6).toFixed(2)}`)
  }

  priceText = numberWithCommas(priceText);;
  
  return '$' + priceText;
}

function numberWithCommas(x) {
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x))
      x = x.replace(pattern, "$1,$2");
  return x;
}

function updateLaybuyPrice(price){
  $('.first-instalment-price .laybuy-money[data-money-convertible]').text(price)
}

$(document).ready(function() {
    // Function to check if element is available
    function checkElement() {
        if ($('.utils-compare-toggle__container').length) {
            // Element is available, trigger click event
            $('.utils-compare-toggle__container').trigger('click');
        } else {
            // Element not available yet, wait and check again
            setTimeout(checkElement, 100); // Check again in 100 milliseconds
        }
    }

    // Start checking for the element
    checkElement();
});


// // Track when items are added to the cart
// document.addEventListener('rebuy:cart.add', (event) => {
//   console.log('Item added to cart:', event.detail);
// });

// // Track when the cart is updated (items added, removed, or quantities changed)
// document.addEventListener('rebuy:cart.update', (event) => {
//   console.log('Cart updated:', event.detail);
//   const cartTotal = event.detail.cart.total_price;
//   console.log('Updated cart total:', cartTotal);
// });

// Track when the cart changes - general
document.addEventListener('rebuy:cart.change', (event) => {
  // console.log('Cart changed:', event);
  let cartSubTotal = (event.detail.cart.cart.total_price) * 0.01;
  
  let active_freegift = document.querySelector('.freegift-status .active_freegift').value;
  if (active_freegift){
    waitForElm('#rebuy-custom-code-block-header.freegift').then((elm) => {
      updateFreeGift(cartSubTotal);
      hideErrorPopup()
    });

  }
});

// // Track when items are removed from the cart
// document.addEventListener('rebuy:cart.remove', (event) => {
//   console.log('Item removed from cart:', event.detail);
// });

// // Track when the cart drawer opens
// document.addEventListener('rebuy:cart.open', (event) => {
//   console.log('Cart opened:', event.detail);
// });

// function waitForElm(selector) {
//   return new Promise(resolve => {if (document.querySelector(selector)) {return resolve(document.querySelector(selector));}const observer = new MutationObserver(mutations => {if (document.querySelector(selector)) {resolve(document.querySelector(selector));observer.disconnect();}});observer.observe(document.body, {childList: true,subtree: true});});
// }

function waitForElm(selector) {
  return new Promise(resolve => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }
    
    const observer = new MutationObserver((mutations) => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  });
}
function waitForClass(element, className) {
  return new Promise(resolve => {
    if (element.classList.contains(className)) {
      return resolve();
    }
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
          if (element.classList.contains(className)) {
            resolve();
            observer.disconnect();
          }
        }
      });
    });
    observer.observe(element, { attributes: true });
  });
}

function updateFreeGift(cartSubtotal) {
  console.log('## updateFreeGift', cartSubtotal)
  
  let container = document.querySelector('#rebuy-custom-code-block-header.freegift');
  if (!container) {
    console.log("Container #rebuy-custom-code-block-header.freegift not found");
    return;
  }

  if (cartSubtotal == 0){
    container.innerHTML = '';
    $('#rebuy-custom-code-block-header.freegift').removeClass('freegift_msg_appened');
    return;
  }
  
  let thresholds = Array.from(document.querySelectorAll('.freegift-status .threshold')).map(input => ({
    threshold: parseInt(input.value),
    title: input.dataset.pTitle,
    handle: input.dataset.pHandle
  }));

  thresholds.sort((a, b) => a.threshold - b.threshold);

  let freeGift = null;
  let nextThreshold = null;
  let amountNeeded = 0;

  for (let i = 0; i < thresholds.length; i++) {
    if (cartSubtotal >= thresholds[i].threshold) {
      freeGift = thresholds[i];
    } else {
      nextThreshold = thresholds[i];
      break;
    }
  }

  if (nextThreshold && nextThreshold.handle != '') {
    amountNeeded = nextThreshold.threshold - cartSubtotal;
    if(amountNeeded < 0) amountNeeded = 0;
  }

  let html = '';
  let freegift_msg = "You've unlocked a free gift: " //document.querySelector('.freegift-status .freegift_msg').value;

  if (nextThreshold) {
    amountNeeded = amountNeeded.toFixed(2)
    
    if (freeGift && Number(freeGift.threshold) === 0) {
      // No free gift yet
      tier_msg = `Spend $${amountNeeded} more and receive a free gift: ` // document.querySelector('.freegift-status .tier_msg').value;
    } else {
      // at least 1 free gift available
      let freegift_msg = "You've unlocked a free gift: " //document.querySelector('.freegift-status .freegift_msg').value;
      tier_msg = `Spend $${amountNeeded} more and upgrade your free gift to `
    }
    // tier_msg = tier_msg.replace('[price]', amountNeeded).replace(/\.$/, '');
  }

  if (freeGift && Number(freeGift.threshold) > 0) {
    html += `
      <div class="gift_wrap_confirmed">
        <h5 class="message">${freegift_msg}<a href="/products/${freeGift.handle}">${freeGift.title}</a></h5>
      </div>
    `;
  }

  if (nextThreshold && nextThreshold.handle != '') {
    html += `
      <div class="gift_wrap_target">
        <h5 class="message">${tier_msg}<a href="/products/${nextThreshold.handle}">${nextThreshold.title}</a></h5>
      </div>
    `;
  }

  container.innerHTML = ''
  container.innerHTML = html;
  $('#rebuy-custom-code-block-header.freegift').addClass('freegift_msg_appened');

}

async function hideErrorPopup() {
  let modal = await waitForElm('#rebuy-modal');
  // Then wait for the modal to have the 'is-visible' class
  await waitForClass(modal.querySelector('.rebuy-notification-modal'), 'is-visible');
  // Now check the error message and remove modal if applicable
  let errormsg = modal.querySelector('.rebuy-notification-dialog-header')?.textContent || '';
  if (errormsg.includes('updates parameter is invalid')) {
    modal.remove();
    document.body.classList.remove('rebuy-modal-visible');
    console.warn('Removed modal due to error message: updates parameter is invalid');
  }
}